<template>
    <div>
        <div class="row form-group">
            <div class="col-4 text-right">
                <label>เลือกธนาคาร</label>
            </div>
            <div class="col-6">
                <b-form-select v-model="form.bank_id" :options="optionBankType">
                </b-form-select>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">
                <label>รหัสสาขา</label>
            </div>
            <div class="col-6">
                <input class="form-control" v-model="form.branch_code" placeholder="รหัสสาขา"/>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">
                <label>ชื่อสาขา</label>
            </div>
            <div class="col-6">
                <input class="form-control" v-model="form.name" placeholder="ชื่อสาขา"/>
            </div>
        </div>
        <div class="col text-center">
            <button class="btn btn-success" @click="submitData">
                <icon name="save" style="width: 25px"></icon>
                บันทึก
            </button> &nbsp;&nbsp;
            <button class="btn btn-outline-secondary" @click="cancelData">
                <icon name="times" style="width: 25px"></icon>
                ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "BankBranchModal",
        props : {form : Object},
        created() {
        },
        computed:{
            ...mapState({
                optionBankType:state=>{
                    return [
                        {
                            value: "",
                            text: "เลือกธนาคาร"
                        },
                        ...state.Common.bank_type.map(type => ({
                            value: type.id,
                            text: type.name
                        }))
                    ];
                },
            })
        },
        methods:{
            submitData(){
                this.$emit("submit",this.form);
            },
            cancelData(){
                this.$emit("submit",false);
            }
        }
    }
</script>

<style scoped>

</style>
